/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */

import { __ } from '@oat-sa-private/ui-core';

/**
 * Get a saved (human time ago) string
 * @param {Number} lastTimestamp
 * @returns {String}
 */
export function getTimeSince(lastTimestamp = Date.now()) {
    const lastDate = new Date(lastTimestamp);
    const ageSeconds = (Date.now() - lastDate) / 1000;

    const timeThresholds = [
        { thresholdSeconds: 60, toHumanTime: () => __('saved') },
        { thresholdSeconds: 2 * 60, toHumanTime: () => __('saved 1 minute ago') },
        { thresholdSeconds: 60 * 60, toHumanTime: s => __('saved %d minutes ago', Math.floor(s / 60)) },
        { thresholdSeconds: 2 * 60 * 60, toHumanTime: () => __('saved 1 hour ago') },
        { thresholdSeconds: 24 * 60 * 60, toHumanTime: s => __('saved %d hours ago', Math.floor(s / 3600)) }
    ];
    for (const { thresholdSeconds, toHumanTime } of timeThresholds) {
        if (ageSeconds < thresholdSeconds) {
            return toHumanTime(ageSeconds);
        }
    }

    // if no match within time thresholds, final time string should have localized date
    const testLocale = __.getLocale() || document.documentElement.lang || 'en';
    return __('last saved on %s', lastDate.toLocaleDateString(testLocale));
}
